import React from "react"
import { Card, CardBody, Col, Button } from "reactstrap"

function Header({ onAdd }) {
  return (
    <Card>
      <CardBody>
        <Col>
          <div className="float-start">
            <h5 className="text-primary">Appointment Systems</h5>
          </div>
          <div className="float-end">
            <Button color="primary" size="sm" onClick={onAdd}>
              Add New System
            </Button>
          </div>
        </Col>
      </CardBody>
    </Card>
  )
}

export default Header